import { createStore } from '@souche-f2e/muji';
import API from '@/services';
import { notification } from 'antd';
const checkUserInfo = {
    checkTransferData: [],
    tradeSuccessTransferType: 0,
};
export default createStore({
    state: Object.assign(Object.assign({}, checkUserInfo), { modalVisible: false }),
    effects: {
        // 查看过户信息
        checkTransInfo(params, state) {
            API.order.queryTransferInfo({ orderId: params.orderId, carVin: params.carVin }).then((data) => {
                if (data) {
                    this.SET_STATE({
                        checkTransferData: data.modelGroup,
                        tradeSuccessTransferType: data.transferType,
                        modalVisible: true
                    });
                }
                else {
                    notification.warning({ message: '未查询到信息' });
                }
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        }
    },
});
